export const ENVIRONMENT_OPTIONS = ['dev', 'stage', 'prod']

export const STATUS_OPTIONS = ['draft', 'published', 'archived']

export const KIND_OPTIONS = [
  { text: 'Content', value: 'content' },
  { text: 'Fragment', value: 'fragment' },
]